import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";

const Header = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Hide header entirely for logged-in users (sidebar handles navigation)
  if (user) return null;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="max-w-screen mx-auto px-4 h-14 flex items-center justify-between">
        <button
          onClick={() => navigate("/")}
          className="font-mono font-bold text-sm text-primary tracking-wider hover:opacity-80 transition-opacity"
        >
          FINFLUENCER AUDIT
        </button>

        {!loading && !user && (
          <Button
            variant="outline"
            size="sm"
            className="gap-2"
            onClick={() => navigate(`/login?returnTo=${encodeURIComponent(location.pathname + location.search)}`)}
          >
            <LogIn className="w-4 h-4" />
            Sign in
          </Button>
        )}
      </div>
    </header>
  );
};

export default Header;
